import { Divider, Flex, VStack } from '@chakra-ui/react';

import type { FetchService } from '@izimi/api';

import { useNabanModule } from '../modules/useNabanModule';
import type { AuthenticationMethod } from '../store';
import { getAuthenticationMethodsItems } from '../utils';
import { AuthenticationMethodsListItem } from './AuthenticationMethodsListItem';

type Props = {
  fetchService: FetchService;
  onItemSelection?: (item: AuthenticationMethod) => void;
};

export const AuthenticationMethodsList = ({ onItemSelection, fetchService }: Props) => {
  const { useGetNabanAuthenticationModes } = useNabanModule(fetchService);
  const { nabanAuthenticationModes } = useGetNabanAuthenticationModes();
  const items = getAuthenticationMethodsItems({ data: nabanAuthenticationModes });

  return (
    <VStack divider={<Divider borderColor='neutral200' />} role='group'>
      {items.map((item) => {
        if (Array.isArray(item)) {
          return (
            <Flex key={item[0]?.token} flexDirection='column' w='full' gap={1}>
              {item.map((i) => (
                <AuthenticationMethodsListItem
                  key={i.token}
                  item={i}
                  onItemSelection={onItemSelection}
                  testId={i.token}
                />
              ))}
            </Flex>
          );
        }
        return (
          <AuthenticationMethodsListItem
            key={item.token}
            item={item}
            onItemSelection={onItemSelection}
            testId={item.token}
          />
        );
      })}
    </VStack>
  );
};
